<template>
  <div id="header">
    <div class="wrap_box">
      <h1><a href="/">IdleGuildMaster</a></h1>
      <!-- <p v-if="user_info.userid != ''" class="head_name">{{ info.username }}({{ info.userid }})</p> -->
      <!-- <div id="gnb2"> -->
      <!-- <router-link v-if="user_info.userid != ''" :to="{ path: '/myinfo' }">회원정보 수정</router-link> -->
      <!-- </div> -->
      <div id="gnb">
        <p class="ver">For v{{ site_info.latest_update_version }} / Latest update: {{ site_info.latest_update_date }}
        </p>
        <div class="gnb_sub_part">
          <div class="gnb_row_group">
            <div class="lan_icon_wrapper" @click="change_lan()">
              <transition name="fade" mode="out-in">
                <img class="lan_icon" :key="lanIcon" :src="lanIcon" />
              </transition>
            </div>
            <button style=" height: 24px;" @click="toggleDarkMode">
              {{ isDarkMode ? '🌙' : '☀️' }}
            </button>
          </div>

          <!-- 버튼 박스는 아래로 -->
          <div class="btn_box" v-if="!except_route_list.includes(this.$route.name)">
            <a class="btn size1" v-if="user_info.userid != ''" @click="logout()">{{ getTrans('logout') }}</a>
            <a class="btn size1" v-else @click="login()">{{ getTrans('login') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import common from "@/common/common.js";
import config from "@/common/config.js";
export default {
  data: function () {
    return {
      isDarkMode: false,
      user_info: { userid: "", username: "", nickname: "" },
      site_info: { latest_update_date: "", latest_update_version: "", },
      except_route_list: [
        "Join", "Login"
      ],
    }
  },
  computed: {
    lanIcon() {
      return this.$store.state.lan == 'kor' || this.$store.state.lan == 'KR'
        ? require('@/assets/lan_icon/kor.png')
        : require('@/assets/lan_icon/eng.png');
    },
    currentLang() {
      return this.$store.state.lan; // 또는 원하는 방식으로 현재 언어 상태 가져오기
    },
  },
  created() {
    // 사용자 설정 기억
    this.isDarkMode = localStorage.getItem('dark') === 'true';
    if (this.isDarkMode) {
      document.documentElement.classList.add('dark');
    }
  },
  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      localStorage.setItem('dark', this.isDarkMode);
      document.documentElement.classList.toggle('dark', this.isDarkMode);
    },
    getTrans(type) {
      const translation = config.trans[type];
      if (translation) {
        return translation[this.currentLang] || translation['kor']; // 기본값으로 'kor' 선택
      }
      return type; // 기본값으로 type을 반환 (해당 번역이 없을 경우)
    },
    login() {
      location.href = '/login';
    },
    async logout() {
      let tm = this.getTrans('alert_logout');
      if (confirm(tm)) {
        let logout_result = await common.logout(this.$store.state.token);
        if (logout_result) {
          this.user_info = { userid: "", username: "", nickname: "" };
          this.$store.commit('set_token', ""); // 토큰 제거
          location.href = '/';
        }
      }
    },
    getSiteInfo() {
      axios({
        url: config.apiurl + "/system/site/getSettings",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        method: "POST",
        data: {
          // token: this.$store.state.token,
        },
      })
        .then((response) => {
          let d = response.data;
          // console.log(d);
          if (d.result == 1) {
            this.site_info = d.site_info;
            // console.log(this.site_info);
          }
        })
        .catch(function (error) {
          alert("오류가 발생했습니다...(getSettings)");
          console.log(error);
        });
    },
    change_lan() {
      this.$store.commit('change_lan');
    }
  },
  mounted: async function () {
    let user_info = await common.get_info(this.$store.state.token);

    if (user_info !== undefined) {
      this.user_info = user_info;
      this.$store.commit('set_user_info', user_info); // 유저정보 저장
    }

    this.getSiteInfo();
  },
};
</script>


<style>
.head_name {
  color: white;
}
</style>

<style>
/* 페이드 효과 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>